var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tabs',{staticClass:"LayoutNavbarHorizontal",attrs:{"grow":""}},[_c('v-tabs-slider',{attrs:{"color":"primary"}}),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }